export default __webpack_public_path__ + "3e2c6f6fec8984414ee7c02260408ce2.mp3";